import { Component, OnInit } from "@angular/core";
import { DataService_ScheduledJobs } from "../scheduled-reports/shared/data.service";
import { DataService_Inbox } from "./shared/data.service";
import { Router } from "@angular/router";
import { ConfirmationService } from "primeng/api";
import { MenuService } from "../../master/services";

@Component({
	selector: "app-report-inbox",
	templateUrl: "./report-inbox.component.html",
	styleUrls: ["./report-inbox.component.css"],
})
export class ReportInboxComponent implements OnInit {
	constructor(
		private dataService: DataService_Inbox,
		private router: Router,
		private confirmationService: ConfirmationService,
		private menuService: MenuService
	) {}

	ngOnInit(): void {
		this.loadInbox();
	}

	////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////

	pagerows: any = 10;
	pagefirst: any = 0;

	SelectedInbox: any;
	lstInbox: any = [];
	LoadingInbox: boolean = false;

	lstUnreadDesc: any = [];

	cols: any = [
		{ field: "JobDesc", header: "Report" },
		{ field: "Subject", header: "Subject" },
		{ field: "Body", header: "Body" },
		{ field: "c_dateDesc", header: "Date" },
	];

	Proccessing: boolean = false;
	errorMessage: any = "";

	////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////////////

	loadInbox() {
		this.errorMessage = "";
		this.SelectedInbox = null;

		this.LoadingInbox = true;

		var result = this.dataService.InboxSelectList();
		result.subscribe(
			(response) => {
				this.lstInbox = response;

				this.lstUnreadDesc = Array.from(new Set(this.lstInbox.map((item: any) => item.UnreadDesc))).sort();

				this.menuService.reportInboxChanged("Refresh");

				this.LoadingInbox = false;
			},
			(error) => {
				this.LoadingInbox = false;
			}
		);
	}

	////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////////

	onRefresh() {
		this.loadInbox();
	}

	onViewReport() {
		this.errorMessage = "";

		if (this.SelectedInbox == undefined || this.SelectedInbox.InboxID <= 0) {
			this.errorMessage = "Select a report to view";
			return;
		}

		this.router.navigate(["inboxreport/inbox/" + this.SelectedInbox.InboxID]);
	}

	onDelete() {
		this.errorMessage = "";

		if (this.SelectedInbox == undefined || this.SelectedInbox.InboxID <= 0) {
			this.errorMessage = "Select a report to delete";
			return;
		}

		this.confirmationService.confirm({
			key: "inboxconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Are you sure you want to delete this report?",
			header: "Confirm Delete",
			icon: "fa",
			accept: () => {
				this.onFinishDelete();
			},
		});
	}

	onFinishDelete() {
		this.Proccessing = true;

		var result = this.dataService.InboxDelete(this.SelectedInbox.InboxID);
		result.subscribe(
			(response: any) => {
				this.Proccessing = false;

				if (response.Success == true) {
					this.confirmationService.confirm({
						key: "inbox",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Report was deleted successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadInbox();
						},
					});
				} else {
					this.confirmationService.confirm({
						key: "inbox",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not delete the report: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Proccessing = false;
			}
		);
	}

	onDeleteAll() {
		this.errorMessage = "";

		this.confirmationService.confirm({
			key: "inboxconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: "Are you sure you want to delete all the items in your inbox?",
			header: "Confirm Delete",
			icon: "fa",
			accept: () => {
				this.onFinishDeleteAll();
			},
		});
	}

	onFinishDeleteAll() {
		this.Proccessing = true;

		var result = this.dataService.InboxDeleteAll();
		result.subscribe(
			(response: any) => {
				this.Proccessing = false;

				if (response.Success == true) {
					this.confirmationService.confirm({
						key: "inbox",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Inbox was cleared successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadInbox();
						},
					});
				} else {
					this.confirmationService.confirm({
						key: "inbox",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not clear your inbox: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Proccessing = false;
			}
		);
	}

	onReadToggle(InboxID: number) {
		this.Proccessing = true;

		var result = this.dataService.InboxToggleRead(InboxID);
		result.subscribe(
			(response) => {
				this.menuService.reportInboxChanged("Refresh");
				this.Proccessing = false;
			},
			(error) => {
				this.Proccessing = false;
			}
		);
	}

	////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////////////

	onRowDblClick(Inbox) {
		if (this.IsLoading() == true) {
			return;
		}

		this.SelectedInbox = Inbox;
		this.onViewReport();
	}

	////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingInbox == true || this.Proccessing == true;
	}

	////////////////////////////////////////////////////////
}
